import React, { useEffect, useState, useRef, useCallback } from 'react';
import Icon from '@mdi/react';
import {
  mdiBullhorn,
  mdiClockOutline,
  mdiAccountCircleOutline,
} from '@mdi/js';
import beepSound from '../assets/sound/beep-29.mp3';

const FETCH_INTERVAL_MS = 2 * 60 * 1000; // 2 minute

const AdminNoticesBar = () => {
  const [notices, setNotices] = useState([]);
  const lastIdsRef = useRef([]);
  const audioRef = useRef(null);

  const formatCreator = useCallback((creator) => {
    if (!creator) return '—';
    if (creator.username) return creator.username;
    const full = [creator.name, creator.surname].filter(Boolean).join(' ');
    return full || '—';
  }, []);

  const fetchNotices = useCallback(async () => {
    try {

      const res = await window.axios.get('/notices/active', {
        params: { limit: 5 },
      });

      const data = res?.data?.data || [];

      // detekcija novih poruka
      const newIds = data.map((n) => n.id);
      const prevIds = lastIdsRef.current;
      const isNewStuff =
        newIds.length > 0 &&
        (prevIds.length === 0 ||
          newIds.some((id) => !prevIds.includes(id)));

      setNotices(data);
      lastIdsRef.current = newIds;

      if (isNewStuff && audioRef.current) {
        audioRef.current.play().catch(() => {});
      }
    } catch (err) {
      console.warn(
        'Greška kod dohvaćanja obavijesti:',
        err?.response?.data || err.message
      );
    }
  }, []);

  useEffect(() => {
    fetchNotices();
    const t = setInterval(fetchNotices, FETCH_INTERVAL_MS);
    return () => clearInterval(t);
  }, [fetchNotices]);


  if (!notices || notices.length === 0) {
    return (
      <>
        <audio ref={audioRef} src={beepSound} preload="auto" />
      </>
    );
  }

  return (
    <>
      <audio ref={audioRef} src={beepSound} preload="auto" />

      <div className="pl-2 pr-4 mt-0 flex flex-col gap-1 bg-blue-gray-50 pt-1">

        {notices.map((n) => {
          const creatorLabel = formatCreator(n.creator);
          return (
            <div
              key={n.id}
              className="bg-red-700 rounded-sm text-white shadow mt-1"
            >
              <div className="mx-auto px-4 sm:px-6 lg:px-8">
                <div className="flex h-11 items-center justify-between">

                  <div className="flex items-start gap-2 min-w-0">
                    <div className="flex-shrink-0 leading-none pt-[2px]">
                      <Icon
                        path={mdiBullhorn}
                        size={0.8}
                        className="text-white"
                      />
                    </div>

                    <div className="min-w-0 leading-tight">
                      <div className="font-semibold text-[13px] text-white truncate max-w-[50vw] sm:max-w-[40vw]">
                        {n.title}
                      </div>
                      <div className="text-[12px] text-white/90 truncate max-w-[60vw] sm:max-w-[45vw]">
                        {n.body}
                      </div>
                    </div>
                  </div>

                  <div className="flex flex-row flex-wrap justify-end items-center gap-x-3 gap-y-1 text-[10px] sm:text-[11px] leading-tight text-white text-right flex-shrink-0">


                    <span className="flex items-center gap-1 text-white uppercase font-medium">
                      <Icon
                        path={mdiClockOutline}
                        size={0.7}
                        className="text-white"
                      />
                      <span>AKTIVNO DO</span>
                      <span className="font-semibold normal-case text-white">
                        {n.ends_at_f ? n.ends_at_f : 'bez roka'}
                      </span>
                    </span>


                    <span className="hidden sm:inline text-white/60">|</span>


                    <span className="flex items-center gap-1 text-white uppercase font-medium">
                      <Icon
                        path={mdiAccountCircleOutline}
                        size={0.7}
                        className="text-white"
                      />
                      <span className="font-semibold normal-case break-all text-white">
                        {creatorLabel}
                      </span>
                    </span>

                  </div>
                </div>
              </div>
            </div>
          );
        })}

      </div>
    </>
  );
};

export default AdminNoticesBar;
